export class MediaMetaData {
    height: number;
    width: number;
    fileType: string;
    fileFormat: string;
    name: string;
    duration: number;

    constructor(
        height: number = 0,
        width: number = 0,
        fileType: string = "",
        fileFormat: string = "",
        name: string = "",
        duration: number = 0,
    ) {
        this.height = height;
        this.width = width;
        this.fileType = fileType;
        this.fileFormat = fileFormat;
        this.name = name;
        this.duration = duration;
    }
}

export class Media {
    url: string;
    metaData: MediaMetaData;

    constructor(url: string = "", metaData: MediaMetaData = new MediaMetaData()) {
        this.url = url;
        this.metaData = metaData;
    }
}